import {metadaApi} from '@dms/api/base';

import {
  GetTransferOrderBasketRequest,
  GetTransferOrderBasketResponse,
  GetTransferOrderBasketRequestSchema,
  GetTransferOrderBasketResponseSchema,
  CheckoutTransferOrderBasketResponse,
  CheckoutTransferOrderBasketRequest,
  CheckoutTransferOrderBasketRequestSchema,
  CheckoutTransferOrderBasketResponseSchema,
  DiscardTransferOrderBasketRequest,
  DiscardTransferOrderBasketResponse,
  DiscardTransferOrderBasketRequestSchema,
  DiscardTransferOrderBasketResponseSchema,
} from './types';

export const metadaWarehouseTransferOrderBasketApi = metadaApi.injectEndpoints({
  endpoints: (build) => ({
    getTransferOrderBasket: build.query<
      GetTransferOrderBasketResponse,
      GetTransferOrderBasketRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/transfer-order/${queryArg.transferOrderId}/basket`,
        method: 'GET',
        queryArg,
      }),
      providesTags: (result, error, queryArg) => [
        {type: 'transferOrderBasket', id: queryArg.transferOrderId},
      ],
      extraOptions: {
        requestSchema: GetTransferOrderBasketRequestSchema,
        responseSchema: GetTransferOrderBasketResponseSchema,
      },
    }),
    checkoutTransferOrderBasket: build.mutation<
      CheckoutTransferOrderBasketResponse,
      CheckoutTransferOrderBasketRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/transfer-order/${queryArg.transferOrderId}/basket/checkout`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'transferOrderBasket', id: queryArg.transferOrderId},
        {type: 'transferOrders', id: queryArg.transferOrderId},
        'headerDynamicActions',
      ],
      extraOptions: {
        requestSchema: CheckoutTransferOrderBasketRequestSchema,
        responseSchema: CheckoutTransferOrderBasketResponseSchema,
      },
    }),
    discardTransferOrderBasket: build.mutation<
      DiscardTransferOrderBasketResponse,
      DiscardTransferOrderBasketRequest
    >({
      query: (queryArg) => ({
        url: `warehouse/v1/transfer-order/${queryArg.transferOrderId}/basket/discard`,
        method: 'POST',
        queryArg,
      }),
      invalidatesTags: (result, error, queryArg) => [
        {type: 'transferOrderBasket', id: queryArg.transferOrderId},
        {type: 'transferOrders', id: queryArg.transferOrderId},
        {type: 'headerDynamicActions', id: queryArg.transferOrderId},
      ],
      extraOptions: {
        requestSchema: DiscardTransferOrderBasketRequestSchema,
        responseSchema: DiscardTransferOrderBasketResponseSchema,
      },
    }),
  }),
});

export const {
  useGetTransferOrderBasketQuery,
  useCheckoutTransferOrderBasketMutation,
  useDiscardTransferOrderBasketMutation,
} = metadaWarehouseTransferOrderBasketApi;
